import { useState, useCallback } from 'react';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';

interface WithdrawalsFiltersState {
  walletIds: string[];
}

export const useWithdrawalsFilters = ({
  initialConditions,
  onChange,
}: {
  initialConditions: FilterConditionOutput[];
  onChange?: (conditions: FilterConditionOutput[]) => void;
}) => {
  const parseConditions = (conditions: FilterConditionOutput[]): WithdrawalsFiltersState => {
    const state: WithdrawalsFiltersState = {
      walletIds: [],
    };

    conditions.forEach((condition) => {
      if (condition.column === 'wallet_id' && condition.action === 'in' && Array.isArray(condition.value)) {
        state.walletIds = condition.value as string[];
      }
    });

    return state;
  };

  const [filters, setFilters] = useState<WithdrawalsFiltersState>(() => parseConditions(initialConditions));

  const convertToConditions = useCallback((state: WithdrawalsFiltersState) => {
    const conditions: FilterConditionOutput[] = [];

    if (state.walletIds.length > 0) {
      conditions.push({
        column: 'wallet_id',
        action: 'in',
        value: state.walletIds,
      });
    }

    return conditions;
  }, []);

  const handleFilterChange = (key: keyof WithdrawalsFiltersState, value: any) => {
    setFilters((prev) => {
      const next = { ...prev, [key]: value };
      onChange?.(convertToConditions(next));
      return next;
    });
  };

  const clearFilters = () => {
    const next = {
      walletIds: [],
    };
    setFilters(next);
    onChange?.(convertToConditions(next));
  };

  return {
    filters,
    handleFilterChange,
    clearFilters,
  };
};
